 
import React, { useEffect, useState } from 'react';
import moment from 'moment';

import {
  capitalize,
  formatTime,
  capitalizeFullname
} from 'v3/utils/formatter';

import { Link } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';

import ApplicationLayout from 'v3/layouts/Application';
import { Attachment } from 'v3/components/Attachment';
import { EditBlacklit } from 'v3/pages/BlackList/Pages/Details/Modal/Edit';
import { Divider } from '@mui/material';

import Text from 'v3/components/Text';
import Card from 'v3/components/Card';
import Button from 'v3/components/Button';
import Fallback from 'v3/components/Fallback';

import { validatePermission } from 'actions/index';

import { useBlacklist } from '../../context';
import { usePermission } from 'hooks';

import {
  formatLabelLog,
  formatNameCard
} from 'v3/pages/BlackList/controller';

import * as Styled from './styles';

export function BlacklistItemDetails() {

  usePermission('VISUALIZAR_MOTIVO_BLACKLIST', { redirect: true });

  const { blacklist,
    setData,
    data,
    loading,
    updateBlacklist,
    error,
    editBlacklistModal,
    setErrors
  } = useBlacklist()

  const [hasPermissionToEdit, setPermissionToEdit] = useState(false);

  useEffect(() => {
    setPermissionToEdit(validatePermission('ALTERAR_BLACKLIST'));
  }, []);


  return (
    <ApplicationLayout
      title="Detalhes do item da blacklist"
      RightComponent={
        <Col style={{ display: 'flex', gap: '1rem', justifyContent: 'flex-end' }}>
          <Link to="/blacklist">
            <Button variant="secondary">
              <Text weight={500} type="regular">
                Voltar
              </Text>
            </Button>
          </Link>
        </Col>
      }
    >
      <Row>
        <Col lg={7} md={8} xs={12}>
          <Card
            key={data}
            loading={loading}
            header={
              <>
                <Text color="#464E5F" type="header">
                  {formatLabelLog(blacklist?.blacklistType?.slug)}
                </Text>
                {
                  hasPermissionToEdit && (
                    <Button
                      className="mt-3 py-2"
                      onClick={() => {
                        editBlacklistModal.open();
                      }}
                    >
                      <Text type="regular" weight="500" color="white">
                        {blacklist?.active ? 'Desbloquear' : 'Bloquear'}
                      </Text>
                    </Button>
                  )
                }
              </>
            }
          >
            <Row>
              <Col>
                <Text>{formatNameCard(blacklist)}</Text>
              </Col>
              <Col>
                {blacklist?.active ? (
                  <Styled.Badge pill light type="error" className="mr-2">
                    <Text type="label">Bloqueado</Text>
                  </Styled.Badge>
                ) : (
                  <Styled.Badge pill light type="success" className="mr-2">
                    <Text type="label">Desbloqueado</Text>
                  </Styled.Badge>
                )}
              </Col>
            </Row>
          </Card>

          {blacklist && (
            <div className="mt-4">
              <Card
                key={data}
                loading={loading}
                header={
                  <>
                    <Text type="header" color="dark">
                      Histórico
                    </Text>
                  </>
                }
              >
                <Fallback
                  loading={false}
                  fall={blacklist?.logs?.length === 0}
                  component={<Text>Nenhum evento enviado</Text>}
                >
                  {blacklist.logs.map((item) =>
                    <Styled.Container key={item?.id || item?.createdAt}>
                      <div className="mb-1">
                        <Text weight={500} color="dark">
                          {moment(item?.createdAt).format('DD/MM/YYYY')}
                        </Text>
                      </div>
                      <Styled.Marker style={{ marginBottom: 5 }} />

                      <Styled.Tray>
                        <Styled.FeedItem>
                          <div className="mb-2">
                            <Text weight={500} color="dark">
                              {formatTime(item?.createdAt)}
                            </Text>
                            {' - '}
                            <Text weight={500} color="dark">
                              {capitalize(item?.title)}
                            </Text>
                          </div>

                          <Col style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '0.5rem',
                            marginBottom: '0.5rem',
                            wordWrap: 'break-word'
                          }}>
                            <Text type='regular' color="gray">
                              Motivo: {item?.reason}
                            </Text>

                            <Divider />

                            <Text type='regular' color="gray">
                              Descrição: {item?.description}
                            </Text>
                          </Col>

                          <Text as="div" type="label" color="gray">
                            Criado por {capitalizeFullname(item?.user?.username)}
                          </Text>
                          <hr />

                          {item?.medias?.length > 0 && (
                            <>
                              {
                                item?.medias?.map((media, index, data) => (
                                  <Attachment
                                    key={media?.id || media?.full_path || index}
                                    deleteOption={false}
                                    attachment={media}
                                    attachments={data}
                                  />
                                ))
                              }
                            </>
                          )}
                        </Styled.FeedItem>
                      </Styled.Tray>
                      <div className="mb-3">
                        <Styled.Marker $isLast />
                      </div>
                    </Styled.Container>
                  )}
                </Fallback>
              </Card>
            </div>
          )}
        </Col>
      </Row>
      <EditBlacklit
        show={editBlacklistModal.isOpen}
        onClose={editBlacklistModal.close}
        blacklist={blacklist}
        setData={setData}
        data={data}
        loading={loading}
        updateBlacklist={updateBlacklist}
        error={error}
        setErrors={setErrors}
      />
    </ApplicationLayout>
  );
}
